
import AdminTrans from "../components/superadmin/AdminTransaction";

export default function SuperTransaction() {
  return (
    <div>
      <AdminTrans />
    </div>
  );
}
